import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Storage from "../../utils/storage";
import { useHistory } from "react-router-dom";
import { Form, Formik, Field } from "formik";
import { RegisterAppSchema } from "../../utils/validation";
import Logo from "../../assets/assets/Nibss-Logo.png";
import Button2 from "../../components/Button/Button2";
import Button3 from "../../components/Button/Button3";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";
import FormInput3 from "../../components/FormInput/FormInput3";
import jwt_decode from "jwt-decode";
import { PropTypes } from "prop-types";
import FormSelect3 from "../../components/FormSelect/FormSelect3";

const ApplicationForm2 = ({
  appStatus,
  getStatus,
}) => {

  const history = useHistory();

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let name = user && user.name;

  let userToken = Storage.get("user-access-token");
  const token = jwt_decode(userToken)
  let userCompanyId = token && token.id

  const osOptions = [
    {
      id: 1,
      name: "Android",
      value: "Android",
      disabled: false,
    },
    {
      id: 2,
      name: "Linux",
      value: "Linux",
      disabled: false,
    },
  ];

  const merchantClassOptions = [
    {
      id: 1,
      name: "Merchant",
      value: "001",
      disabled: false,
    },
    {
      id: 2,
      name: "Micro-Merchant",
      value: "002",
      disabled: false,
    },
    {
      id: 3,
      name: "Agent",
      value: "003",
      disabled: false,
    },
  ];

  useEffect(
    () => {
      getStatus();
    },
    // eslint-disable-next-line
    [getStatus]
  );

  const goToApply = () => {
    history.push("/apply");
  };

  const initialValues = {
    application_name: "",
    application_version: "",
    device: "",
    device_model: "",

    device_longitude: "",
    device_latitude: "",
    posDevice_type:"",
    merchant_class: "",
    application_bvn: "",
    application_tin: ""

  };

  const submitApplication = (value) => {
    const application = {
      company_id: userCompanyId,
      application_name: value.application_name,
      application_version: value.application_version,
      device: value.device,
      device_model: value.device_model,

      device_longitude: value.device_longitude,
      device_latitude: value.device_latitude,
      posDevice_type: value.posDevice_type,
      merchant_class: value.merchant_class,
      application_bvn: value.application_bvn,
      application_tin: value.application_tin

    };
    history.push({
      pathname: "/application/upload",
      state: {
        application: application,
      },
    });
  };

  return (
    <div className="application">
      <Link to="/dashboard">
        {" "}
        <div className="application-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>

      <div className="application-start-form">
        <div className="form4"></div>
        <div className="application-start-form-header">
          <h1>Hello {name}</h1>
          <h3>
            Let's get you <br /> started
          </h3>
          <p>Provide the information of the POS Application</p>
        </div>

        <div className="application-wrap">
          <Formik
            initialValues={initialValues}
            validationSchema={RegisterAppSchema}
            onSubmit={submitApplication}
          >
            {({ values, isValid, dirty }) => {
              const disable1 =
                values.application_name === "" ||
                values.application_version === "" ||
                values.device === "" ||
                values.device_model === "" ||
                values.device_longitude === "" ||
                values.device_latitude === "" ||
                values.posDevice_type === ""
              return (
                <Form id="form">
                  <div className="form-1">
                    <div className="app-input">
                      <Field
                        name="application_name"
                        label="POS Application Name"
                        placeholder="Enter POS application name"
                        component={FormInput3}
                      />
                    </div>
                    <div className="app-input2">
                        <Field name="merchant_class">
                          {(val) => (
                            <FormSelect3
                              id="formselect"
                              options={merchantClassOptions}
                              label="Merchant Class"
                              placeholder="Select Option"
                              {...val}
                            />
                          )}
                        </Field>
                      </div>
                      <div className="app-input">
                      <Field
                        name="application_bvn"
                        label="Application BVN 11 Digits"
                        placeholder="Enter BVN for the Application Owner (PTSP)"
                        component={FormInput3}
                      />
                    </div>
                    <div className="app-input">
                      <Field
                        name="application_tin"
                        label="Application TIN (E.g 342-000993)"
                        placeholder="Enter TIN for the Application Owner PTSP)"
                        component={FormInput3}
                      />
                    </div>

                    <div className="app-input">
                      <Field
                        name="application_version"
                        label="Specify Model/Version of POS"
                        placeholder="Enter model/version of POS"
                        component={FormInput3}
                      />
                    </div>

                    <div className="app-input">
                      <Field
                        name="device"
                        label="Specify Certified Device To Use With Application"
                        placeholder="Specify certified device name"
                        component={FormInput3}
                      />
                    </div>

                    <div className="app-input">
                      <Field
                        name="device_model"
                        label="Specify Certified Device Model"
                        placeholder="Specify certified device model"
                        component={FormInput3}
                      />
                    </div>
                    <div className="app-input">
                      <Field
                        name="device_longitude"
                         label="Specify Device Longitude Coordinates (E.g 0.000993)"
                        placeholder="Specify certified device longitude coordinates"
                        component={FormInput3}
                      />
                    </div>

                    <div className="app-input">
                      <Field
                        name="device_latitude"
                        label="Specify Device Latitude Coordinates (E.g 0.000993)"
                        placeholder="Specify certified device latitude coordinates"
                        component={FormInput3}
                      />
                    </div>


                    <div className="app-input2">
                        <Field name="posDevice_type">
                          {(val) => (
                            <FormSelect3
                              id="formselect"
                              options={osOptions}
                              label="POS OS Device Type"
                              placeholder="Select Option"
                              {...val}
                            />
                          )}
                        </Field>
                      </div>
                    

                    <div className="application-wrap-buttons">
                      <Button2
                        width="45%"
                        height="45px"
                        word={"Back"}
                        onClick={goToApply}
                      />
                      <Button3
                        width="45%"
                        height="45px"
                        word={"Proceed"}
                        type={"submit"}
                        disabled={disable1 || !(isValid && dirty)}
                      />
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    appStatus: state.docs.status,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStatus: () => dispatch(getUserStatus()),
});

ApplicationForm2.propTypes = {
  appStatus: PropTypes.array,
  getStatus: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationForm2);
